<template>
  <div class="stepper-box">
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>

    <horizontal-stepper
      locale="pt"
      v-if="steps != null"
      :steps="steps"
      :keep-alive="false"
      :reset="true"
      @stepper-finished="finalizar"
      @completed-step="completeStep"
      @active-step="isStepActive"
    />
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import HorizontalStepper from "@/horizontal-stepper";
import store from "../../store";
import axios from "axios";

//Steps
import ImagemJornalzinho from "./steps/1_ImagemJornalzinho";
import FinalizarJornalzinho from "./steps/2_FinalizarJornalzinho";

import * as config from "@/config.json";

export default {
  name: "jornalzinho",
  components: {
    Loading,
    HorizontalStepper,
  },

  data() {
    return {
      isLoading: false,
      steps: null,
      store,
    };
  },

  methods: {
    limpaLocalStorage() {
      this.removeImagens();
      localStorage.removeItem("jornalzinho");
      localStorage.removeItem("selecionado");
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("dataInicialJornalzinho");
      localStorage.removeItem("dataFinalJornalzinho");
    },

    fillSteps() {
      this.steps = [
        {
          icon: "image",
          name: "imagem-jornalzinho",
          title: "Imagem do Jornalzinho",
          component: ImagemJornalzinho,
        },
        {
          icon: "check_box",
          name: "finalizar",
          title: "Finalizar",
          component: FinalizarJornalzinho,
        },
      ];
    },

    // Executed when @completed-step event is triggered
    completeStep(payload) {
      //this.isLoading = true;
      this.steps.forEach((step) => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },

    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.steps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },

    trataImagens() {
      return this.store.imagemJornal.map((image) => image.imagem);
    },

    removeImagens() {
      for (let i = 1; i <= this.qtdePaginas; i++) {
        sessionStorage.removeItem(`image-${i}`);
      }
    },

    async buildData(
      empresaid,
      cnpj,
      promocaoid_local,
      titulo,
      descricao,
      imagem,
      data_inicial,
      data_final,
      showText
    ) {
      const dataInicial = moment(data_inicial).format("YYYY-MM-DD 00:00:00");
      const dataFinal = moment(data_final).format("YYYY-MM-DD 23:59:59");

      return {
        empresaid: empresaid,
        cnpj: cnpj,
        promocaoid_local: promocaoid_local,
        titulo: titulo,
        descricao: descricao,
        imagem: imagem,
        data_inicial: dataInicial,
        data_final: dataFinal,
        showText: showText,
      };
    },

    async finalizar() {
      this.isLoading = true;
      var havepush = localStorage.getItem("have-push");
      const url = `${config.default.servidor}/gerencial/jornalzinho`;

      const data = await this.buildData(
        localStorage.getItem("enterprise_id"),
        localStorage.getItem("cnpj"),
        0,
        localStorage.getItem("titulo"),
        localStorage.getItem("descricao"),
        this.trataImagens(),
        localStorage.getItem("dataInicialJornalzinho"),
        localStorage.getItem("dataFinalJornalzinho"),
        localStorage.getItem("show-text")
      );

      try {
        const response = await axios({
          url,
          method: "put",
          data,
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.isLoading = false;

          store.limpaStore();

          await this.$alert("Jornalzinho vinculado!", "Sucesso", "success");

          if (havepush == "true") {
            localStorage.setItem("redirectid", response.data.cod_promocao);
            localStorage.setItem("tipoid", "1");
            localStorage.setItem("chamadaCampanha", "Jornalzinho");
            localStorage.setItem(
              "tituloJornalzinho",
              localStorage.getItem("titulo")
            );
            localStorage.setItem(
              "descricaoJornalzinho",
              localStorage.getItem("descricao")
            );

            this.$router.push({ path: `/cadastrar-campanha` });
          } else {
            this.$router.push({ path: `/jornalzinho` });
          }
        }

        this.limpaLocalStorage();
      } catch (error) {
        this.isLoading = false;
        this.$alert("Falha no vínculo do jornalzinho!", "Erro", "error");
        console.log({ error });
      }
    },
  },

  beforeMount() {
    this.isLoading = true;
    store.limpaStore();
    this.fillSteps();
    this.isLoading = false;
  },
};
</script>

<style src="./jornalzinho.scss" scoped lang="scss">